import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-292339c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "el-dialog__body-title" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "table" }
const _hoisted_4 = { class: "table-thead" }
const _hoisted_5 = { class: "table-body" }
const _hoisted_6 = {
  key: 2,
  class: "flex-cen-ter",
  style: {"flex-direction":"column"}
}

import { t } from '@/plugins/i18n'
import { ref, reactive, watch } from 'vue'
import { getJapanTime } from '@/util/common'
import { getPayoneerList, uploadVoucher } from '@/apis/fund'
import Upload from '@/components/common/Upload.vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible', 'refresh'],
  setup(__props, { emit }) {

const props = __props


const columns = [
  { prop: 'balanceRechargeId', label: t('流水号') },
  { prop: 'balanceRechargeStatus', label: t('状态') },
  { prop: 'remittanceAmount', label: t('存入金额（USD）') },
  { prop: 'createTime', label: t('创建时间') }
]

const tableData: any = ref([])
const store = useStore()

const balanceRechargeStatusDict: any = {
  1: t('待初审'),
  2: t('待终审'),
  3: t('已通过'),
  4: t('已拒绝')
}
watch(() => props.visible, (newValue) => {
  if (newValue) {
    init()
  }
})

const init = () => {
  getPayoneerList({
    customerId: store.getters.user.customerId,
    systemSource: store.getters.plat === 'd2c' ? '1' : '2'
  }).then((res: any) => {
    tableData.value = res.data.records ?? []
  })
}

const setFile = (file: any, row: any) => {
  if (file?.raw.url) {
    uploadVoucher({
      voucherUrl: file?.raw.url || '',
      balanceRechargeId: row.balanceRechargeId
    }).then((res: any) => {
      if (res.success) {
        ElMessage.success(t('上传成功'))
        init()
      }
    })
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    "model-value": __props.visible,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', false)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('payoneer充值记录')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
                return _createElementVNode("th", {
                  key: item.prop,
                  width: "200"
                }, _toDisplayString(item.label), 1)
              }), 64))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((tableData.value || []), (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.balanceRechargeId
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (v) => {
                  return _createElementVNode("td", {
                    key: v.prop
                  }, [
                    (v.prop === 'createTime')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
                        ], 64))
                      : (v.prop === 'balanceRechargeStatus')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(balanceRechargeStatusDict[row.balanceRechargeStatus]), 1)
                          ], 64))
                        : (v.prop === 'remittanceAmount')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                              _createTextVNode(_toDisplayString(row.remittanceAmount) + " ", 1),
                              (!row.uploadedVoucher && row.balanceRechargeStatus == 2)
                                ? (_openBlock(), _createBlock(Upload, {
                                    key: 0,
                                    "limit-file": { accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf' },
                                    onChange: ($event: any) => (setFile($event,row))
                                  }, {
                                    trigger: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "text",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)('点击上传凭证')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["limit-file", "onChange"]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row[v.prop]), 1)
                            ], 64))
                  ])
                }), 64))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})